<template lang="pug">
  .lei-filter(:class="{select, multiple, disabled, custom}")
    .button-wrap(:class="{selected: isSelected, active: showFilter}")
      .category(@click="toggleFilter")
        lei-popover.filter-label-tip-box(:text="tip", :placement="tipPlacement", :width="tipWidth",)
          a.name {{name}}
      .select-block(@click="toggleFilter")
        .value-wrap(v-if="!multiple")
          slot(name="choice", :choice="value")
            p {{getLabel(value)}}
        .multiple-value-wrap(v-if="multiple && i < maxVisibleItems", v-for="v,i in value", :key="i")
          slot(name="choice", :choice="v")
            p {{getLabel(v)}}
          i.close.el-icon-circle-close(@click.stop="removeItem(v, i)")
        p.unplaced(v-if="showTipForItems") and {{unplacedItemsCount}} more
        i.caret.el-icon-arrow-down(:class="{open: showFilter}")
      .choice-block(v-if="isSelected" )
        .value-wrap(v-if="!multiple")
          slot(name="choice", :choice="value")
            a.choice {{getLabel(value)}}
          i.close.el-icon-circle-close(@click="remove")
        .multiple-value-wrap(v-if="multiple && i < maxVisibleItems", v-for="v,i in value", :key="i")
          slot(name="choice", :choice="v")
            p {{getLabel(v)}}
          i.close.el-icon-circle-close(@click.stop="removeItem(v, i)")
        p.unplaced(v-if="showTipForItems") and {{unplacedItemsCount}} more
      .editor.align-center(@click="toggleFilter")
        font-awesome-icon.pen(icon="pen" size="lg")
    autocomplete(
      :dropdown-mode="dropdownMode",
      v-if="showFilter",
      root-class="filter-wrap",
      :multiple="multiple",
      :items="filteredInternalItems",
      :focus-on-create="true",
      :get-label='getLabel',
      :min-len='0',
      @update-items='update',
      @item-selected="itemSelected",
      @item-clicked="itemClicked")
      template(slot-scope="{ item }")
        slot(:item="item")
          .autocomplete-item(:class="{'item-selected': selected(item)}") {{getLabel(item)}}
        i.icon-check.el-icon-check(v-if="selected(item)")
    .substrate(v-if="showFilter", @click.self="closeFilter")
</template>

<script>
import Autocomplete from './Autocomplete'
import LeiPopover from '../LeiPopover'
import { mapActions, } from 'vuex'
import includes from 'lodash/includes'

export default {
  components: {
    LeiPopover,
    Autocomplete,
  },
  props: {
    dropdownMode: {
      type: Boolean,
      default: false,
    },
    autoItems: {
      type: Boolean,
      default: false,
    },
    index: {
      type: Number,
      default: 0,
    },
    filter: {
      type: Object,
      default: () => {
      },
    },
    items: {
      type: Array,
      default: () => [],
    },
    chosenField: {
      type: Array,
      default: () => [],
    },
    initialValue: {
      type: [ Object, String, Array, ],
      default: null,
    },
    getLabel: {
      type: Function,
      default: (item) => item,
    },
    select: {
      type: Boolean,
      default: false,
    },
    custom: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    maxVisibleItems: {
      type: Number,
      default: 1,
    },
    id: {
      type: [ String, Number, ],
      default: null,
    },
    name: {
      type: String,
      required: true,
    },
    tip: {
      type: [ Object, String, ],
      default: () => ({
        small: '',
        full: '',
      }),
    },
    tipPlacement: {
      type: String,
      default: 'bottom',
    },
    tipWidth: {
      type: Number,
      default: 220,
    },
  },
  data () {
    return {
      showFilter: false,
      internalItems: [],
      handledItems: [],
      value: '',
    }
  },
  computed: {
    isSelected () {
      return !!this.value
    },
    showTipForItems () {
      return this.multiple && this.value.length > this.maxVisibleItems
    },
    unplacedItemsCount () {
      return this.value.length - this.maxVisibleItems
    },
    filteredInternalItems () {
      return this.internalItems.filter((item) => {
        if (this.chosenField.includes(item.id)) {
          return false
        }
        if (this.filter && this.filter.restrictedOptions) {
          if (item.id) {
            return !this.filter.restrictedOptions.find((restrictedOption) => restrictedOption.id === item.id)
          } else {
            return !this.filter.restrictedOptions.includes(item)
          }
        }
        return true
      })
    },
  },
  watch: {
    'initialValue': function (val) {
      this.value = val
    },
    'items': function (val) {
      this.handledItems = val
    },
    'handledItems': function (val) {
      this.internalItems = val
    },
  },
  async mounted () {
    if (this.initialValue) this.value = this.initialValue
    this.handledItems = this.autoItems && this.items.length === 0 ? await this.handleItems() : this.items
  },
  created () {
    if (this.multiple) this.value = []
  },
  methods: {
    remove () {
      const { id, index, filter, } = this
      this.value = ''
      this.$emit('remove', {
        id,
        index,
        filter,
      })
    },
    toggleFilter () {
      if (!this.disabled) this.showFilter = !this.showFilter
    },
    closeFilter () {
      this.showFilter = false
      this.update('')
    },
    itemSelected (item) {
      this.multiple ? this.multipleSelected(item) : this.closeFilter()
      // console.log('You selected an item!', item)
      const { id, index, filter, value, } = this
      this.$emit('choose', {
        item,
        id,
        index,
        filter,
        value,
      })
    },
    multipleSelected (item) {
      this.update('')
      const index = this.value.findIndex((val) => item === val)
      index !== -1 ? this.value.splice(index, 1) : this.value.push(item)
    },
    removeItem (item, i) {
      this.value.splice(i, 1)
      const { id, index, filter, value, } = this
      this.$emit('change', {
        item,
        id,
        index,
        filter,
        value,
      })
    },
    selected (item) {
      const gl = this.getLabel
      return Array.isArray(this.value) ? this.value.map((v) => gl(v)).includes(gl(item)) : gl(this.value) === gl(item)
    },
    itemClicked (item) {
      // console.log('You clicked an item!', item)
    },
    handleItems () {
      const hasResources = this.filter.data_type === 'RESOURCE'
      return hasResources ? this.getResources(this.filter.resource) : this.filter.enum
    },
    update (text) {
      this.internalItems = this.handledItems.filter((item) => {
        return includes(this.getLabel(item).toLowerCase(), text.toLowerCase())
      })
    },

    ...mapActions('search', [ 'getResources', ]),
  },
}
</script>

<style lang="stylus">
  @import "../../../assets/styles/variables.styl"

  .lei-filter
    position relative
    margin 0 10px 25px 0


    .button-wrap
      height 40px
      min-width 80px
      display flex
      width auto
      font-size .75rem
      font-weight 600
      border-radius 20px
      color $default-color-bold

      .editor
        display none

      .close
        font-weight 500
        margin-left 5px
        font-size 0.75rem
        line-height 0.75rem
        color $default-color

        &:hover
          cursor pointer
          color $danger-color

      .select-block
        display none

        &:hover i
          color $turquoise-color !important

      .category
        border-radius 20px
        width 100%
        display flex
        cursor pointer
        align-items center
        text-align center
        padding 0 20px

        &:hover
          background-color #94EBDE


      .value-wrap
        min-width 0
        display flex
        align-items center
        justify-content center

      &.selected
        .category
          border-radius 20px 0 0 20px
          width auto

        .choice-block
          padding 0 20px
          background-color $white-color
          border-radius 0 20px 20px 0
          display: grid
          align-items center
          justify-content center
          width fit-content

          .choice
            display flex
            align-items center

          .close
            margin-left 10px
            font-size 0.9rem
            line-height 0.9rem

    &.multiple
      .button-wrap
        .select-block, .choice-block
          overflow hidden

          .multiple-value-wrap
            max-width calc(100% - 80px)
            display flex
            align-items center
            justify-content space-around
            font-size 85%
            margin-right 3px
            height 85%
            padding-left 6px
            padding-right 4px
            border-radius 4px
            background-color $default-color-light-2

            p
              line-height 1.5
              max-width 100%
              white-space nowrap
              overflow hidden
              text-overflow ellipsis

          .unplaced
            white-space nowrap
            font-weight 600
            margin-left 5px
            font-size 80%

    &.disabled:hover
      .button-wrap
        .select-block, .choice-block
          cursor not-allowed !important

    .filter-wrap
      position absolute
      z-index 3
      transform translateY(100%)
      bottom -10px
      left 0
      height fit-content
      background-color $white-color
      border 1px solid $default-color-bold
      overflow-x hidden
      width 100%
      min-width 280px

      .autocomplete
      .autocomplete-input-group
        margin 10px

        .autocomplete-input
          width 100%
          font-size .75rem
          padding 10px 15px
          box-shadow none
          border 1px solid $cyprus-color
          outline none
          background-color $white-color

        &.autocomplete-selected
          .autocomplete-input
            background-color $white-color

      .autocomplete-list
        padding-bottom 5px
        width 100%
        text-align left
        max-height 165px
        height fit-content
        overflow-x hidden
        overflow-y auto

        .autocomplete-list-item
          flex 1
          position relative
          cursor pointer
          display flex
          align-items center
          padding 10px 12px
          color $default-color-bold
          font-size .75rem
          font-weight 600

          &:hover, &.autocomplete-item-active
            background-color $primary-color-light-3

          .autocomplete-item
            display flex
            align-items center

            &.item-selected
              color $turquoise-color

          .icon-check
            font-weight bold
            color $turquoise-color
            position absolute
            right 10px

    .substrate
      z-index 1
      background-color transparent
      display block
      position fixed
      top 0
      left 0
      width 100vw
      height 100vh

  @media screen and (min-width: $laptop-min)
    .lei-filter.select
      display flex
      margin 0 15px 10px 0

      .button-wrap
        height auto
        min-width 80px
        flex 1
        flex-direction column
        border-radius 0
        color $default-color-bold

        &.selected
          .category
            border-radius 0
            width fit-content

          .choice-block
            display none

        .select-block
          cursor pointer
          font-size 1rem
          font-weight 500
          display flex
          height $input-md
          background-color $white-color
          padding 8px 35px 8px 10px
          align-items center
          position relative
          border 1px solid $default-color

          .caret
            position absolute
            right 8px
            top 50%
            font-weight 600
            transform translateY(-50%)
            color $default-color-middle
            font-size 1.35rem
            transition all 0.3s ease

            &.open
              top 25%
              transform rotateZ(180deg)

        .category
          font-size 0.85rem
          font-weight 600
          background-color transparent
          border-radius 0
          width 100%
          display flex
          align-items center
          justify-content flex-start
          text-align left
          padding 10px 0

      &.disabled
        .button-wrap
          color $disabled-color

          .select-block
            background-color $disabled-bg
            border-color $disabled-border

          .caret
            color $disabled-color

  @media (max-width: $tablet)
    .lei-filter.custom
      border-bottom 1px solid $default-color-light-1
      width 100%
      margin 0

      &:first-child
        border-top 1px solid $default-color-light-1

      .button-wrap
        padding 0 20px
        background-color $default-color-light-2
        min-width auto
        width 100%
        font-weight 500
        border-radius 0

        .category
          text-align left
          background-color transparent
          padding 0
          border-radius 0
          display flex
          justify-content space-between

        .editor
          display flex
          color $default-color

          &:hover
            color $primary-color
            cursor pointer

        &.selected
          .category
            border-radius 0

          .choice-block
            flex 1
            padding 0 15px
            background-color transparent
            border-radius 0
            justify-content flex-start

            .choice
              color $default-color-bold
              font-weight 600
              display: inline-block

            .remove
              color $default-color

              .remove-icon
                background-color $white-color
                border-radius 50%

      .filter-wrap
        bottom 0
        background-color $default-color-light-2
        border-color $default-color-light-1
        border-right none
        border-left none
        min-width 100%
        box-shadow $box-shadow-middle

        .autocomplete
        .autocomplete-input-group
          margin 10px 20px

          .autocomplete-input
            border-color $default-color-bold

          &.autocomplete-selected
            .autocomplete-input
              background-color $white-color

        .autocomplete-list
          .autocomplete-list-item
            padding 10px 20px

            &:hover, &.autocomplete-item-active
              background-color $default-color-light-1

</style>



// WEBPACK FOOTER //
// src/components/lei-components/inputs/LeiFilter.vue